/**
 * Copy for the booking sheet, taken from the iOS tour flow (TourFlow feature)
 * with the web-specific variants the 1-pager calls out. Keep strings here so
 * design review has one place to diff against the Figma mocks.
 */
export const TOUR_SHEET_COPY = {
  sheetTitle: 'Book a self tour',
  slot: {
    heading: 'Tour this home',
    subheading: 'Pick a time that works for you. Tours take about 30 minutes.',
    emptyState: 'No self-tour times in the next 5 days',
    tourWithAgent: 'Tour with an agent',
    tourNow: 'Tour now',
    tourNowCaption: 'A 30-minute tour is available right now.',
    continue: 'Continue',
  },
  login: {
    heading: 'Sign in to book your tour',
    body: 'Sign in or create an account to pick up where you left off.',
    continue: 'Continue',
  },
  phone: {
    heading: 'Add your mobile number',
    body: 'We use it for tour-day door access. You’ll verify it in the Opendoor app.',
    save: 'Continue',
    saveFailed: 'We couldn’t save your number. Please try again.',
  },
  review: {
    heading: 'Review your tour',
    confirm: 'Confirm tour',
    slotTaken: 'That time was just booked. Pick another time.',
    outsideHours: 'That time is outside self-tour hours (8am to 7pm). Pick another time.',
    unauthorized: 'Please sign in and try again.',
    timeout: 'We couldn’t confirm your booking in time. Check My tours before trying again.',
    unknown: 'Something went wrong. Please try again.',
  },
  confirmation: {
    heading: 'Self tour booked!',
    body: 'We’ll see you at the home. You can manage this tour from My tours.',
    viewMyTours: 'View my tours',
    addToCalendar: 'Add to calendar',
    appHandoff:
      'Finish setup in the Opendoor app before tour day: verify your phone number and identity for one-tap door unlock.',
  },
  contactSupport: {
    heading: 'We’re sorry, we can’t book this tour online',
    body: 'Please contact our support team at (844) 961-2722 to finish setting up your tour.',
  },
} as const;
